import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

const stepArray = [{
    title1: 'Select',
    title2: 'your plan',
    description: 'Choose a plan that works for you and complete the payment.'
}, {
    title1: 'Welcome',
    title2: 'call',
    description: 'Connect with our team and complete a form to customize your preferences'
}, {
    title1: 'Schedule',
    title2: 'call',
    description: 'A call with the nutritionist is scheduled to understand your health goals better'
}, {
    title1: 'Receive',
    title2: 'your plan',
    description: 'Get your diet plan with actionable goals within 72 hrs of the consult.'
}, {
    title1: 'Follow up',
    title2: 'with team',
    description: 'You can chat and request for calls at your convenience with the team.'
}]
const StepCarousal = () => {

    const Step = ({stepData, count}) => (
        <div>
            <span className='step-lable'>Step-{count+1}</span>
            <h1 className='payment-title mb-2'><span className='yellow'>{stepData.title1}</span> {stepData.title2}</h1>
            <p className='payment-subtext mb-5 step-description'>{stepData.description}</p>
        </div>
    );

    return(
        <div className='step-carousal'>
            <Carousel autoPlay={false} dynamicHeight={false} showArrows={false} showStatus={false} showThumbs={false}>
                {stepArray.map((st, i) => <Step stepData={st} count={i} key={i} />)}
            </Carousel>
        </div>
    );
}

export default StepCarousal;